import client from "../request"

const create = (id, data) => {
  return client.post(`/pamms/${id}/unsubscribe`, data)
}

export default {
  create,
}
